module.exports = __webpack_public_path__ + "assets/tosit-31f73e.svg";